import { render } from "./OwnerShipDetails.vue?vue&type=template&id=643f8260&scoped=true"
import script from "./OwnerShipDetails.vue?vue&type=script&lang=js"
export * from "./OwnerShipDetails.vue?vue&type=script&lang=js"

import "./OwnerShipDetails.vue?vue&type=style&index=0&id=643f8260&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-643f8260"]])

export default __exports__